export default "__VITE_ASSET__Blr1Lnla__"